import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-add-module',
  templateUrl: './add-module.component.html',
  styleUrls: ['./add-module.component.scss'],
})
export class AddModuleComponent implements OnInit {
  isLoading: boolean = false;
  @Input() courseDetailToEdit: any;
  @Input() moduleDetailToEdit: any;
  listOfResources: any = [];
  defaultCoverImage = null;
  showAddNewResources: boolean = false;
  disable: boolean = true;
  selectedFile: any = null;
  selectedFileName: any = 'No File Selected';
  editResources: boolean = false;
  editLinks: boolean = false;
  listOfDescription: any = [];
  myHeaders = new Headers();
  userDetails: any;
  formdata = new FormData();
  @Output() closeSideForm: EventEmitter<any> = new EventEmitter();

  moduleNameFormControl = new FormControl('', [Validators.required]);
  PositionFormControl = new FormControl('', [Validators.required]);
  addModuleForm: FormGroup = new FormGroup({
    moduleName: this.moduleNameFormControl,
    position: this.PositionFormControl,
  });
  constructor(
    private matDialog: MatDialog,
    public as: AppService,
    public routes: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.addModuleForm = this.formBuilder.group({
      moduleName: this.moduleNameFormControl,
      position: this.PositionFormControl,
    });
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    if (this.moduleDetailToEdit != null) {
      this.addModuleForm
        .get('moduleName')
        ?.setValue(this.moduleDetailToEdit['name']);
      this.addModuleForm
        .get('position')
        ?.setValue(this.moduleDetailToEdit['position']);
    } else {
      this.showAddNewResources = true;
      this.addModuleForm.get('moduleName')?.setValue('');
    }
  }
  getModuleNameErrorMessage() {
    return this.moduleNameFormControl.hasError('required')
      ? 'Please enter module name'
      : '';
  }
  getPositionErrorMessage() {
    return this.PositionFormControl.hasError('required')
      ? 'Please enter module position'
      : '';
  }
  handlePickedFile(event: any) {
    this.selectedFile = event.target.files[0];
    this.selectedFileName = this.selectedFile['name'];
    this.formdata.set('offerImage', this.selectedFile, this.selectedFileName);
    var reader = new FileReader();
    reader.onload = (event1: any) => {
      this.defaultCoverImage = event1.target.result;
    };
    reader.readAsDataURL(this.selectedFile);
  }
  addNewResources() {
    this.showAddNewResources = true;
  }

  async addNewModule() {
    this.isLoading = true;
    var param;
    var URL;
    this.formdata = new FormData();

    if (this.moduleDetailToEdit != null) {
      this.formdata.set('moduleId', this.moduleDetailToEdit['_id']);
    } else {
      this.formdata.set('moduleId', '0');
    }
    this.formdata.set('course', this.courseDetailToEdit['_id']);
    this.formdata.set('name', this.addModuleForm.get('moduleName')?.value);
    this.formdata.set('position', this.addModuleForm.get('position')?.value);

    URL = `${webApi.domain + webApi.endPoint.createAndUpdateModule}`;

    this.myHeaders.append(
      'Authorization',
      `Bearer ${this.userDetails['accessToken']}`
    );

    var requestOptions: RequestInit = {
      method: 'POST',
      headers: this.myHeaders,
      body: this.formdata,
      redirect: 'follow',
    };

    fetch(URL, requestOptions)
      .then((result) => {
        if (result) {
          let data = result.json();
          data.then((res) => {
            if (res['success']) {
              this.isLoading = false;
              this.defaultCoverImage = null;
              this.selectedFile = null;
              this.myHeaders = new Headers();
              if (this.moduleDetailToEdit == null) {
                this.showSuccessToaster(
                  'Module Created Successfully',
                  'Success'
                );
              } else {
                this.showSuccessToaster(
                  'Module Updated Successfully',
                  'Success'
                );
              }
              this.closeSideForm.emit(res['result']);
            } else {
              this.isLoading = false;
              this.myHeaders = new Headers();

              this.showErrorToaster(
                'Some Error occurred while saving data, try again',
                'Error Occurred'
              );
            }
          });
        }
      })
      .catch((error) => {
        this.isLoading = false;
        console.log('error', error);
        this.myHeaders = new Headers();
      });
  }

  cancelEdit(desc: any) {
    this.listOfDescription.forEach((link: any) => {
      link['isEdit'] = false;
    });
    this.editLinks = false;
    desc['isEdit'] = false;
    this.addModuleForm.get('link')?.setValue('');
  }

  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }
  close(source: any) {
    this.addModuleForm.get('moduleName')?.setValue('');
    this.closeSideForm.emit(this.moduleDetailToEdit);
    this.moduleDetailToEdit = null;
  }
}
